import axios, { type AxiosInstance } from "axios";
import { classifyError } from "@rmp/core/api/errors/classifyError";
import { normalizeProblemDetailsErrorResponse } from "@rmp/core/api/errors/problemDetails";
import ApiException from "@rmp/core/exceptions/apiException";

/**
 * Интерцептор классификации ошибок.
 *
 * Автогенный HttpClient отдаёт наружу сырые Axios-ошибки, тогда как сторы ловят
 * доменные исключения через instanceof. Интерцептор конвертирует HTTP-статусы
 * в доменные исключения так же, как это делал legacy-класс Client.
 *
 * Подключается базовым контроллером после auth-interceptor, чтобы сначала дать
 * ему возможность обновить токен и повторить запрос с исходной конфигурацией.
 */
const addErrorInterceptor = (instance: AxiosInstance) => {
	instance.interceptors.response.use(undefined, async error => {
		if(!(error instanceof ApiException) && !axios.isAxiosError(error)) {
			throw error;
		}
		
		await normalizeProblemDetailsErrorResponse(error);
		throw classifyError(error);
	});
};

export default addErrorInterceptor;
